import React, { useState, useRef } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Button, Container, Col, Row, FormGroup } from "reactstrap";
import { HandleContactTyepSubmit } from "../../../../../actions/settings/types/contact_type_actions";
import { TextField, CustomModal } from "../../../../../constants";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const AddContactType = (props) => {
  const dispatch = useDispatch();
  const { is_processing, current_contact_type_obj } = useSelector(
    (state) => state.contactTypeState,
    shallowEqual
  );
  const { modal, toggle } = props;

  const formikRef = useRef();

  const [validateAfterSubmit, setValidateAfterSubmit] = useState(false);

  const validate = Yup.object({
    title: Yup.string().required("Title  is required"),
    description: Yup.string().required("Description is required"),
  });

  return (
    <CustomModal
      modal={modal}
      toggle={toggle}
      tittle={
        current_contact_type_obj.id ? "Edit Contact Type" : "Add Contact Type"
      }
      is_processing={is_processing}
    >
      <Formik
        enableReinitialize
        initialValues={{
          description: current_contact_type_obj.description,
          title: current_contact_type_obj.title,
        }}
        validationSchema={validate}
        validateOnChange={validateAfterSubmit}
        validateOnBlur={true}
        ref={formikRef}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          setValidateAfterSubmit(true);
          dispatch(
            HandleContactTyepSubmit(values, toggle, setErrors, setSubmitting)
          );
        }}
      >
        {(formik) => (
          <Container>
            <Form>
              <FormGroup>
                <Row className="mt-3 ml-1">
                  <Col lg={12} md={12} sm={12} className="my-2">
                    <TextField
                      name="title"
                      type="text"
                      value={formik.values.title}
                      placeholder="Contact type"
                    />
                  </Col>
                  <Col lg={12} md={12} sm={12} className="my-2">
                    <TextField
                      name="description"
                      type="text"
                      value={formik.values.description}
                      placeholder="Description"
                    />
                  </Col>

                  <Col lg={12} md={12} sm={12} className="mt-3">
                    <Button
                      type="submit"
                      className="btn btn-pay btn-block text-white"
                      block
                      disabled={is_processing}
                    >
                      {current_contact_type_obj.id
                        ? is_processing
                          ? "... Updating"
                          : "Update"
                        : is_processing
                        ? "... Creating"
                        : "Create"}
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </Container>
        )}
      </Formik>
    </CustomModal>
  );
};
export default AddContactType;
